/** @format */

export const PERSONALITYLIST = "PERSONALITYLIST";
export const PERSONALITYQUIZ = "PERSONALITYQUIZ";
export const SELECTEDPERSONALITYQUIZDATA = "SELECTEDPERSONALITYQUIZDATA";
export const RESULTPERSONALITYTYPE = "RESULTPERSONALITYTYPE";
export const BEGUNQUIZ = "BEGUNQUIZ";
